module.exports = __webpack_public_path__ + "media/printed-materials/02-educator-handout-frontback-198b6b87.jpg";